import PfcgView from "./pfcg-view.jsx";

export default PfcgView;